import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="42" height="43" viewBox="0 0 42 43" fill="none" {...props}>
      <rect y="0.810059" width="42" height="42" rx="21" fill="#286EFA" />
      <g clipPath="url(#clip0_456_914)">
        <path
          d="M25.5833 17.4167H25.5916M16.8333 13.6667H25.1666C27.4678 13.6667 29.3333 15.5322 29.3333 17.8334V26.1667C29.3333 28.4679 27.4678 30.3334 25.1666 30.3334H16.8333C14.5321 30.3334 12.6666 28.4679 12.6666 26.1667V17.8334C12.6666 15.5322 14.5321 13.6667 16.8333 13.6667ZM24.3333 21.4751C24.4361 22.1686 24.3177 22.8769 23.9948 23.4993C23.6718 24.1216 23.1609 24.6263 22.5346 24.9415C21.9084 25.2567 21.1987 25.3664 20.5064 25.255C19.8142 25.1436 19.1748 24.8168 18.679 24.321C18.1832 23.8253 17.8564 23.1858 17.745 22.4936C17.6336 21.8014 17.7433 21.0917 18.0586 20.4654C18.3738 19.8391 18.8784 19.3282 19.5008 19.0053C20.1231 18.6824 20.8314 18.5639 21.525 18.6667C22.2324 18.7717 22.8873 19.1013 23.393 19.607C23.8987 20.1127 24.2284 20.7676 24.3333 21.4751Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_456_914">
          <rect width="20" height="20" fill="white" transform="translate(11 12)" />
        </clipPath>
      </defs>
    </Svg>
  )
}
